module.exports = __webpack_public_path__ + "58acacc4e951d0b9cd3546e9c43c2d7e.png";